<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description:
-->
<template>
  <div class="lc-excel-import">
    <el-button
      v-bind="$attrs"
      :loading="isShowLoading"
      @click="handleOpenDialog"
    >
      <template v-if="iconPosition === 'right'">
        {{ label }}
      </template>
      <slot v-if="isShowIcon"></slot>
      <template v-if="iconPosition === 'left'">
        {{ label }}
      </template>
    </el-button>

    <el-dialog
      title="上传数据"
      class="lc-excel-import__dialog"
      width="50%"
      append-to-body
      :visible.sync="isShowDialog"
      :modal="true"
      :before-close="handleCloseDialog"
      :close-on-click-modal="false"
    >
      <div class="lc-excel-import__dialog-header">
        <div class="header-piece"></div>
        <span class="header-label">正常数据</span>
        <el-upload
          multiple
          :action="uploadFileAction"
          :accept="uploadFileAccept"
          :auto-upload="false"
          :show-file-list="false"
          :file-list="uploadFileList"
          :on-change="onChangeUploadFile">
          <el-button class="header-btn">导入数据</el-button>
        </el-upload>
        <el-button class="header-btn" @click="handleDownLoadTemplate">下载模板</el-button>
      </div>
      <el-table
        class="lc-excel-import__dialog-table"
        :data="dataList"
        stripe
        style="width: 100%">
        <el-table-column
          prop="isSuccess"
          label="导入状态">
          <template #default="{row}">
            <span
              :class="{
                'import-success': row.isSuccess,
                'import-error': ! row.isSuccess,
              }"
            >
              {{scope.row.isSuccess ? '成功' : '失败'}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="col in headList"
          :key="col.fieldName"
          :prop="col.fieldName"
          :label="col.value"
          :show-overflow-tooltip="true">
          <template #default="{row}">
            <span
              :class="{
                'import-success': row.isSuccess,
                'import-error': ! row.isSuccess,
              }"
            >
              {{scope.row[col.fieldName]}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="handleCloseDialog">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { request } from '@/apis/request'
import { downloadFile } from '@/utils/common.js'

export default {
  name: 'LcExcelImport',
  props: {
    label: {
      type: String,
      default: ''
    },
    isShowIcon: {
      type: Boolean,
      default: true
    },
    iconPosition: {
      type: String,
      default: 'left'
    },
    uploadUrl: {
      type: String,
      default: ''
    },
    downloadUrl: {
      type: String,
      default: ''
    },
    connectors: {
      type: Object,
      default: () => ({
        'downloadErrorDataByApi': {
          queryParams: {},
          resDataName: ''
        },
        'downloadFile': {
          queryParams: {},
          resDataName: ''
        },
        'parseFile': {
          queryParams: {},
          resDataName: ''
        },
      })
    }
  },
  data() {
    return {
      dataList: [],
      headList: [],

      isShowLoading: false,
      isShowDialog: false,

      uploadFileAction: '',
      uploadFileAccept: '.xls,.xlsx',
      uploadFileList: [],
      currentFile: null
    };
  },
  methods: {
    handleOpenDialog() {
      this.isShowDialog = true
    },
    handleCloseDialog() {
      this.isShowDialog = false
    },
    handleDownLoadTemplate() {
      const { queryParams, resDataName } = this.connectors['downloadFile']
      request({
        ...queryParams,
      }).then(res => {
        downloadFile(resDataName ? res[resDataName] : res)
      }).catch(res => {})
    },
    onChangeUploadFile(file, fileList) {
      this.currentFile = file
      const { queryParams, resDataName } = this.connectors['parseFile']
      const formData = new FormData();
      formData.append('file', this.currentFile.raw);
      request({
        ...queryParams,
        data: formData
      }).then(res => {
        const data = resDataName ? res[resDataName] : res
        const {
          dataList,
          errorList,
          headList
        } = data
        this.headList = headList
        this.dataList = [
          ...errorList.map(item => {
            item.isSuccess = false
            return item
          }),
          ...dataList.map(item => {
            item.isSuccess = true
            return item
          })
        ]
      }).catch(res => {})
    },
    handleSubmit() {
      const { queryParams } = this.connectors['uploadFile']
      const formData = new FormData();
      formData.append('file', this.currentFile.raw);
      request({
        ...queryParams,
        data: formData
      }).then(res => {
        if (res.success) {
          this.$message.success('提交成功')
        }
      }).catch(res => {})
    },
  }
};
</script>
